import reduxStore, { AppState } from 'state'

type SubscribeFn = (farms: AppState['farms']) => void
type UnsubscribeFn = () => void
const subscribers = new Set<SubscribeFn>()

export const onReduxFarmChange = (callbackFn: (farms: AppState['farms']) => void): UnsubscribeFn => {
  subscribers.add(callbackFn)
  return () => {
    subscribers.delete(callbackFn)
  }
}

let currentReduxFarmState: AppState['farms']
reduxStore.subscribe(() => {
  const prevFarmState = currentReduxFarmState
  currentReduxFarmState = reduxStore.getState().farms
  if (prevFarmState !== currentReduxFarmState) {
    subscribers.forEach((callbackFn) => callbackFn(currentReduxFarmState))
  }
})
